import { Head, useForm } from '@inertiajs/react'
import { SubmitEvent } from 'react'
import MediaGroupForm from './_form'
import { MediaGroupFormData } from '@/types/shared'

interface MediaGroup {
  id: number
  primary_outlet: string | null
  portfolio_link: string | null
  listing: string
  logo_url: string | null
}

interface Participant {
  id: number
  name: string | null
  location: string | null
  email: string | null
  phone_number: string | null
  instagram: string | null
  youtube: string | null
  flickr: string | null
  facebook: string | null
  tiktok: string | null
  threads: string | null
}

interface EditMediaGroupParticipantProps {
  media_group: MediaGroup
  participant: Participant
  errors?: string[]
}

export default function EditMediaGroupParticipant({ media_group, participant, errors }: EditMediaGroupParticipantProps) {
  const { data, setData, patch, processing } = useForm<MediaGroupFormData>({
    participant: {
      name: participant.name || '',
      location: participant.location || '',
      email: participant.email || '',
      phone_number: participant.phone_number || '',
      instagram: participant.instagram || '',
      youtube: participant.youtube || '',
      flickr: participant.flickr || '',
      facebook: participant.facebook || '',
      tiktok: participant.tiktok || '',
      threads: participant.threads || ''
    },
    media_group: {
      primary_outlet: media_group.primary_outlet || '',
      portfolio_link: media_group.portfolio_link || '',
      listing: media_group.listing || 'photography',
      logo: null
    }
  })

  const handleSubmit = (e: SubmitEvent) => {
    e.preventDefault()
    patch('/media_group_participant', { forceFormData: true })
  }

  return (
    <>
      <Head title="Edit Media Group Profile" />
      <div style={{ padding: "20px", maxWidth: "800px", margin: "0 auto" }}>
        <MediaGroupForm
          data={data}
          setData={setData}
          onSubmit={handleSubmit}
          processing={processing}
          errors={errors}
          title="Edit Media Group Profile"
          submitLabel="Update Media Group Profile"
          currentLogoUrl={media_group.logo_url}
        />
      </div>
    </>
  )
}
